/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line



  //Make product thumbs at bottom of bottom open Zoom popup from top gallery//
    document.querySelector('.product-gallery').addEventListener('click',function(){ 
      var elements = document.querySelectorAll('.lazy-image');
      Array.prototype.forEach.call(elements, function(el, i){
           simulateClick(elements[0]);
      });       
  });
  document.querySelector('.pswp__button--close').addEventListener('click',function(){ 
    setTimeout("document.querySelector('.pswp').classList.remove('pswp--open')",500);
  });
  document.querySelector('.pswp__caption').addEventListener('click',function(){ 
    setTimeout("document.querySelector('.pswp').classList.remove('pswp--open')",500);
  });
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
var simulateClick = function (elem) {
  console.log(elem);
	// Create our event (with options)
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});
	// If cancelled, don't dispatch our event
	var canceled = !elem.dispatchEvent(evt);
};